import styles from "./styles.module.css";
import { css } from "@emotion/react";

export default function StaggeredListItem({
  title,
  image,
  mode,
  color,
  border,
  aspectRatio,
}) {
  return (
    <div className={styles.container}>
      <div
        css={css`
          top: 0;
          left: 0;
          background: ${color ? color : "#FFF"};
          ${!border ? "border: 0px !important;" : ""}
        `}
        className={`${styles.imageContainer} user-selection-disable`}
      >
        <img src={image} style={{}} className={styles.image} />
        <div className={styles.title}>{title?.split(",")[0]}</div>
      </div>
    </div>
  );
}
